import { useEffect, useRef } from 'react';
import { useLocation } from '@tanstack/react-router';
import { useBookmarkSelection } from '../contexts/BookmarkSelectionContext';
import { getListPathFromPathname } from '../utils/readerRouteUtils';

// Exit batch mode when the user navigates to a different list page.
// Reader sub-routes (/folder/x/read/123) are stripped so opening an article
// from within a list does not exit batch mode.
export function useExitBatchModeOnNavigate() {
  const { pathname } = useLocation();
  const { isBatchMode, disableBatchMode } = useBookmarkSelection();
  const previousListPath = useRef(getListPathFromPathname(pathname));

  useEffect(() => {
    const currentListPath = getListPathFromPathname(pathname);
    if (currentListPath === previousListPath.current) return;
    previousListPath.current = currentListPath;
    if (isBatchMode) {
      disableBatchMode();
    }
  }, [pathname, isBatchMode, disableBatchMode]);
}
